import React from 'react';
import { ILegalTransactionGwGFullObject } from '../../../Interfaces/ILegalTransactionGwG';
import { Box, Grid, Typography } from '@mui/material';
import { GwGElement } from './GwGElement';

interface IProps {
  gwgArray: ILegalTransactionGwGFullObject[];
  setGwgArray: Function;
}

export const GwGMain = ({ gwgArray, setGwgArray }: IProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <Typography variant='h5' sx={{ mt: 3 }}>
          Zahlungsrechner
        </Typography>
      </Grid>
      <Grid item sm={12}>
        {gwgArray.map((gwgObject, idx) => (
          <React.Fragment
            key={`gwg-fragment-${gwgObject.idLegalTransactionGwG}`}
          >
            {idx !== 0 && <Box sx={{ mt: 10 }} />}
            <GwGElement
              gwgObject={gwgObject}
              gwgArray={gwgArray}
              setGwgArray={setGwgArray}
            />
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
};
